import { useGetTagsQuery } from '../services/api/tagsApi';

export const useTags = () => {
  const { data: tags = [], ...rest } = useGetTagsQuery(undefined, {
    skip: false,
  });

  return { tags, ...rest };
}; 